import type { EntitlementStoreType } from '../../reducers/entitlement/entitlement'
import { State } from '../../reducers'

const userHavePbpCreditsAvailable = ({ performanceBased }: EntitlementStoreType): boolean => {
  if (!Array.isArray(performanceBased)) return false

  const totalAmountOfPbpCredits = performanceBased.reduce((acc, curr) => acc + (curr?.available ?? 0), 0)

  return totalAmountOfPbpCredits > 0
}

export const getJobUpgrades = ({ entitlements }: State) => entitlements.jobUpgrades
export const getJobPostings = ({ entitlements }: State) => entitlements.jobPostings
export const getPerformanceBasedCredits = ({ entitlements }: State) => entitlements.performanceBased
export const userOwnsPbpCredits = ({ entitlements }: State) => userHavePbpCreditsAvailable(entitlements)
export const getEntitlementsAreLoaded = ({ entitlements: { entitlementsAreLoaded } }: State) => !!entitlementsAreLoaded
